import { useListContext } from 'react-admin';

export const Counter = () => {
  const records = useListContext();
  // console.log('In counter ', { records });
  return <>{records?.data?.length || 0}</>;
};
